import { IBeachType } from '@fr/vue/components/searchFilters/filterList/desktop/components/filterBeachType/filterAttributeMethods';

export default function (ids: number[]): IBeachType['id'] | 0 {
    if (ids.indexOf(136) !== -1) { //Песчаный
        return 1;
    }
    if (ids.indexOf(137) !== -1) { //Галечный
        return 2;
    }
    if (ids.indexOf(211) !== -1) { //Песчано-галечный
        return 3;
    }
    return 0;
}
